export default "/_next/static/chunks/fonts/WhitneySSm-Light-Pro_Web-5183c1bb80f56e2e1c87e33d3993ec6d.woff2";